import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Dashboard from './views/top/Dashboard.vue'
import Map from './views/top/Map.vue'
import His from './views/top/His.vue'
import Event from './views/top/Event.vue'
import Message from './views/top/Message.vue'
import Company from './views/settings/Company.vue'
import User from './views/settings/User.vue'
import Device from './views/settings/Device.vue'
import Report from './views/top/Report.vue'
import Notice from './views/settings/Notice.vue'
import DeviceStatus from './views/settings/DeviceStatus.vue'
import ServiceLog from './views/settings/ServiceLog.vue'
import EnergyPrice from './views/settings/EnergyPrice.vue'
import EnergyLevel from './views/settings/EnergyLevel.vue'
import City from './views/settings/City.vue'
import NormalLayout from './views/NormalLayout.vue'
import SettingsLayout from './views/SettingsLayout.vue'
import EnergyLayout from './views/EnergyLayout.vue'
import Consume from './views/energy/Consume.vue'
import Load from './views/energy/Load.vue'
import ActivePower from './views/energy/ActivePower.vue'
import InActivePower from './views/energy/InActivePower.vue'
import Current from './views/energy/Current.vue'
import Voltage from './views/energy/Voltage.vue'
import PowerFactor from './views/energy/PowerFactor.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
      path: '/dashboard',
      component: Dashboard,
      iconCls: 'fa fa-database',
      role: ['ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_DEMO'],
      name: '状态总览',
      // leaf: true,
      // children: [
      //   { path: '/', component: Map, name: '状态总览' }
      // ]
    },
    {
      path: '/',
      component: NormalLayout,
      hidden: true,
      iconCls: 'fa fa-rocket',
      role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'],
      children: [
        { path: '/', component: Map, name: '设备监控'}
      ]
    },
    {
      path: '/',
      component: NormalLayout,
      iconCls: 'fa fa-rocket',
      role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'],
      children: [
        { path: '/his', component: His, name: '历史数据'}
      ]
    },
    {
      path: '/',
      component: NormalLayout,
      iconCls: 'fa fa-rocket',
      role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'],
      children: [
        { path: '/report', component: Report, name: '诊断报告'}
      ]
    },
    {
      path: '/',
      component: NormalLayout,
      iconCls: 'fa fa-rocket',
      role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'],
      children: [
        { path: '/notice', component: Message, name: '系统通知'}
      ]
    },
    {
      path: '/',
      component: NormalLayout,
      iconCls: 'fa fa-rocket',
      role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'],
      children: [
        { path: '/event', component: Event, name: '报警事件'}
      ]
    },
    {
      path: '/',
      component: NormalLayout,
      iconCls: 'fa fa-rocket',
      children: [
        {
          path: '/settings', role: ['ROLE_ADMIN'], component: SettingsLayout, name: '系统设置',
          children: [
            {
              path: '/settings/company', component: Company, name: '企业管理'
            },
            {
              path: '/settings/user', component: User, name: '用户管理'
            },
            {
              path: '/settings/device', component: Device, name: '设备管理'
            },
            // {
            //   path: '/settings/dtu', component: Dtu, name: 'DTU管理'
            // },
            {
              path: '/settings/energy-level', component: EnergyLevel, name: '阶梯时间管理'
            },
            {
              path: '/settings/energy-price', component: EnergyPrice, name: '费率管理'
            },
            {
              path: '/settings/notice', component: Notice, name: '通知管理'
            },
            {
              path: '/settings/city', component: City, name: '城市管理'
            },
            {
              path: '/settings/device-status', component: DeviceStatus, name: '离线统计'
            },
            {
              path: '/settings/service-log', component: ServiceLog, name: '服务记录'
            }
          ]
        }
      ]
    },
  {
    path: '/',
    component: NormalLayout,
    iconCls: 'fa fa-rocket',
    children: [
      {
        path: '/energy', role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PLATFORM', 'ROLE_GOV', 'ROLE_DEMO'], component: EnergyLayout, name: '能效管理',
        children: [
          {
            path: '/energy/active-power', component: ActivePower, name: '有功功率曲线'
          },
          {
            path: '/energy/inactive-power', component: InActivePower, name: '有功功率曲线'
          },
          {
            path: '/energy/current', component: Current, name: '电流曲线'
          },
          {
            path: '/energy/voltage', component: Voltage, name: '电压曲线'
          },
          {
            path: '/energy/power-factor', component: PowerFactor, name: '功率因素曲线'
          },
          {
            path: '/energy/consume', component: Consume, name: '能耗数据分析'
          },
          {
            path: '/energy/load', component: Load, name: '负荷率分析'
          },
        ]
      }
    ]
  },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js